import React, { Component } from "react";
import { connect } from "react-redux";
import {
    DurableFunctionInstance,
    DurableFunctionInstanceHelpers,
    DurableFunctionInstanceStatus as DurableFunctionInstanceRuntimeStatus
} from "../models/DurableFunctionInstance";
import { IRootState } from "../store";
interface DurableFunctionInstanceStatusProps {
    durableFunctionInstance?: DurableFunctionInstance
    status?: DurableFunctionInstanceRuntimeStatus;

    flex?: string;
    
    pillColourOverride?: string;
    runtimeStatusTextOverride?: string;
    customStatusMessageOverride?: string;
}

interface DurableFunctionInstanceStatusState {

}

class DurableFunctionInstanceStatus extends Component<DurableFunctionInstanceStatusProps, DurableFunctionInstanceStatusState> {

    public static calculateDefaultPillColour = (runtimeStatus?: DurableFunctionInstanceRuntimeStatus): string => {
        
        switch (runtimeStatus) {
            case "Completed":
                return "green";
            case "Running":
                return "amber";
            case "Failed":
                return "red";
            case "Terminated":
                return "black";
            case "Pending":
                return "blue";
            default:
                return "grey";
        }
    }

    private calculateCustomMessage = (instance?: DurableFunctionInstance): string | undefined => {
        if(instance === undefined || instance.customStatus === undefined)
        {
            return undefined;
        }

        let message: string | undefined = undefined;
        if(typeof instance.customStatus === "string")
        {
            message = instance.customStatus;
        }
        else
        {
            message = instance.customStatus?.message || instance.customStatus?.Message;
        }
        
        
        if(instance.runtimeStatus === "Terminated")
        {
            const output = DurableFunctionInstanceHelpers.ParseOutput(instance);
            if(typeof output === "string")
            {
                return output;
            }
            else
            {
                if (message)
                {
                    return `Terminated (Last status message was : ${message})}`;
                }
            }
        }
        
        return message;

    }
    
    
    public render() {
        const flexClass = this.props.flex ? `flex-item--flex-${this.props.flex}` : "";
        
        if (!this.props.durableFunctionInstance && !this.props.status)
        {
            return (
                <div className={`cdb-table__cell ${flexClass}`}>
                </div>
            )
        }
        
        
        let runtimeStatus: DurableFunctionInstanceRuntimeStatus = (this.props.durableFunctionInstance?.runtimeStatus || this.props.status) as DurableFunctionInstanceRuntimeStatus;
        let customMessage = this.props.customStatusMessageOverride || this.calculateCustomMessage(this.props.durableFunctionInstance);
        
        let pillColour = this.props.pillColourOverride || DurableFunctionInstanceStatus.calculateDefaultPillColour(runtimeStatus);         
        let statusText = this.props.runtimeStatusTextOverride ||  runtimeStatus

        let extraDetail: JSX.Element | null = null;
        if (customMessage)
        {
            extraDetail = (
                <span className={"cdb-table__extra-detail cdb-table__extra-detail--ellipsis"}
                    title={customMessage}
                    dangerouslySetInnerHTML={{ __html: customMessage.replace(/CDB Infrastructure Error/, '<span class="cdb-table__extra-detail-highlight"> CDB Infrastructure Error </span>') }}>
                </span>);
        }

        return (
            <div className={`cdb-table__cell ${flexClass}`}>
                <span className={`pill pill--${pillColour} ${customMessage ? "pill--tiny" : ""}`}>
                    {statusText}
                </span>
                {extraDetail}
            </div>
        );
    }
}

export default connect((state: IRootState, ownProps: any): DurableFunctionInstanceStatusProps => {
    return {

    };
})(DurableFunctionInstanceStatus);